export default "__VITE_ASSET__IPvwrAzN__"